import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

const FacebookBrowserAlert = () => {
  const [open, setOpen] = useState(false);

  // Detect Facebook in-app browser
  const isFacebookBrowser = /FBAN|FBAV/.test(navigator.userAgent);

  useEffect(() => {
    if (isFacebookBrowser) {
      // Show the dialog if Facebook browser is detected
      setOpen(true);
    }
  }, [isFacebookBrowser]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{'Switch to External Browser'}</DialogTitle>
      <DialogContent>
        <p>
          You are using the Facebook in-app browser. For the best experience, please open this link in your default
          browser (e.g., Chrome, Safari).
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FacebookBrowserAlert;
